module.exports = __webpack_public_path__ + "img/Greyko.b5881de6.png";